
import { getProvidedApp, getRouter } from '~/base/utils/provided-getter'
import { ISignin, LocalizationPath, UserType } from '@tokyojob/core'
import {
  ButtonFactory,
  CButton,
  CIconFactory,
  getLocalization,
  IconPlacement,
  IconSize,
  RouterLinkFactory
} from '@tokyojob/frontend-components'
import { LocalizationService } from '@tokyojob/frontend-core'
import { defineComponent } from 'vue'
import CLoginForm from '../common/c-login-form.component.vue'
import CSocialLogin from '../common/c-social-login.component.vue'

export default defineComponent({
  components: { CLoginForm, CSocialLogin, CButton },
  setup() {
    const app = getProvidedApp()
    const localization = getLocalization(app)
    const router = getRouter()
    const titleText = LocalizationService.t(localization, LocalizationPath.AgentLoginPageSignIn)
    const accountCreationText = LocalizationService.t(localization, LocalizationPath.AgentLoginHint)
    const createAccountBtn = ButtonFactory.button({
      icon: CIconFactory.Icon({ icon: 'briefcase', placement: IconPlacement.Left, size: IconSize.large }),
      link: RouterLinkFactory.link({ router, link: `/auth/agent/signup` }),
      label: LocalizationService.t(localization, LocalizationPath.AgentSignupBtnText),
      classes: 'theme-shades-medium1-white row-start align-center br-8 p-10 g-10'
    })
    return {
      userType: UserType.Agent,
      titleText,
      accountCreationText,
      createAccountBtn
    }
  },
  methods: {
    /**
     * Pass user info to parent to attempt sign in
     */
    submit(seed: ISignin) {
      this.$emit('submit', seed)
    }
  }
})
